<template>
	<div class="guide-manual">
		<top-bar/>
		<guide-manual/>
		<form-button class="accept-button" @click="acceptTerms" title="Aceitar"/>
	</div>
</template>

<script>
import TopBar from './TopBar.vue';
import GuideManual from '../guide-manual/GuideManual';
import GuideService from '../../service/GuideService';
import FormButton from '../shared/FormButton.vue';

export default {
	components: { TopBar, GuideManual, FormButton },
	data() {
		return {
			service: new GuideService(),
		};
	},
	methods: {
		async acceptTerms() {
			await this.service.acceptTerms();
			this.$router.push('/welcome');
		}
	}
}
</script>

<style lang="scss" scoped>
.accept-button {
	display: block;
	position: fixed;
	bottom: 40px;
	right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/guide-manual-acceptance/GuideManualAcceptance.vue